import type { ContentType } from "@/types/content";
import { getFilterOptions } from "@/utils/content";

interface FilterSidebarProps {
  type: ContentType;
  activeFilter: string;
  onFilterChange: (key: string) => void;
  sort: string;
  onSortChange: (key: string) => void;
}

const sortOptions = [
  { key: "latest", label: "最新发布" },
  { key: "default", label: "默认排序" },
];

const filterTitles: Record<ContentType, string> = {
  plot: "按章节筛选",
  character: "按角色身份筛选",
  news: "按发布时间筛选",
};

export default function FilterSidebar({
  type,
  activeFilter,
  onFilterChange,
  sort,
  onSortChange,
}: FilterSidebarProps) {
  const options = getFilterOptions(type);

  return (
    <div className="space-y-6">
      <div className="bg-background-50 border border-background-200 rounded-lg p-5">
        <h3 className="font-heading font-bold text-sm text-foreground-950 mb-4">
          {filterTitles[type]}
        </h3>
        <div className="flex flex-col gap-1.5">
          {options.map((opt) => (
            <button
              key={opt.key}
              type="button"
              onClick={() => onFilterChange(opt.key)}
              className={`flex items-center justify-between px-3 py-2.5 rounded-md text-sm transition-colors cursor-pointer text-left ${
                activeFilter === opt.key
                  ? "bg-primary-50 text-primary-700 font-medium"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              {opt.label}
              {activeFilter === opt.key && (
                <span className="w-4 h-4 flex items-center justify-center text-primary-600">
                  <i className="ri-check-line"></i>
                </span>
              )}
            </button>
          ))}
        </div>
      </div>

      <div className="bg-background-50 border border-background-200 rounded-lg p-5">
        <h3 className="font-heading font-bold text-sm text-foreground-950 mb-4">排序方式</h3>
        <div className="flex flex-col gap-1.5">
          {sortOptions.map((opt) => (
            <button
              key={opt.key}
              type="button"
              onClick={() => onSortChange(opt.key)}
              className={`flex items-center gap-2 px-3 py-2.5 rounded-md text-sm transition-colors cursor-pointer text-left ${
                sort === opt.key
                  ? "bg-secondary-100 text-secondary-900 font-medium"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={opt.key === "latest" ? "ri-time-line" : "ri-list-check"}></i>
              </span>
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}